import { Box } from '@material-ui/core';

import { TNavbarBrandProps } from './types';

import { AstropayLogo } from 'common/config/assets';

import { NavBarStyles } from './styles';

export const NavbarBrand = ({ NavBarBrandInfo }: TNavbarBrandProps) => {
  const styles = NavBarStyles();

  return !NavBarBrandInfo || !NavBarBrandInfo() ? (
    <Box display="flex">
      <img className={styles.brandImage} src={AstropayLogo} alt="AstroPay" />
    </Box>
  ) : (
    <Box display="flex" height="100%" py={0.5} position="relative" alignItems="flex-end">
      <NavBarBrandInfo />

      <Box className={styles.byAstro} component="span">
        by <img className={styles.brandImage} src={AstropayLogo} alt="AstroPay" />
      </Box>
    </Box>
  );
};
